const APP_CONFIG = {
    N: 100,
    SPECTRUM: [
        // "rgb(222,237,250)"
        "rgb(176,212,243)",
        "rgb(128,186,236)",
        "rgb(77,158,228)",
        "rgb(38,137,223)",
        "rgb(0,116,217)",
        "rgb(0,106,197)",
        // "rgb(0,94,176)"
        // "rgb(0,82,154)"
        // "rgb(0,60,113)"
    ],
}
// TODO REMOVE WORDCLOUD

export class Node implements d3.SimulationNodeDatum {
    index?: number
    x?: number
    y?: number
    vx?: number
    vy?: number
    fx?: number | null
    fy?: number | null

    slug: string
    id: number
    posterImage: string
    posterImageAltText: string

    linkCount: number = 0

    // slug, posterImage, posterImageAltText
    constructor(id, slug, posterImage, posterImageAltText) {
        this.id = id
        this.slug = slug
        this.posterImage = posterImage
        this.posterImageAltText = posterImageAltText
    }

    normal = () => {
        return Math.sqrt(this.linkCount / APP_CONFIG.N)
    }

    get r() {
        return 50 * this.normal() + 10
    }

    get fontSize() {
        return 30 * this.normal() + 10 + "px"
    }

    get color() {
        let index = Math.floor(APP_CONFIG.SPECTRUM.length * this.normal())
        return APP_CONFIG.SPECTRUM[index]
    }
}
